(function($) {
  var ONCE = "___ONCE___";
  
  var Once = function(elem) {
    this.elem = elem;
    this.data = [];
  };
  var _ = Once.prototype;
  
  _.deferred = function(name) {
    if (!name) { return $.Deferred().reject(); }
    var result = this.data[name];
    if (!result) {
      var elem = this.elem;
      result = this.data[name] = $.Deferred().always(function() {
        $(elem).trigger(name);
      });
    }
    return result;
  };
  
  _.reset = function(name) {
    if (!name) { return; }
    var existing = this.data[name];
    if (existing) {
      existing.reject();
      this.data[name] = null;
    }
    return this.deferred(name);
  };
  
  Once.get = function($elem) {
    var result = $elem.data[ONCE];
    if (!result) { result = $elem.data[ONCE] = new Once($elem[0]); }
    return result;
  }
  
  $.fn.extend({
    once: function(name) {
      var once = Once.get(this);
      return name === undefined ? once : once.deferred(name).promise();
    }
  });
})(jQuery);
(function($) {
	const FAIL = "data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==";
	$.extend({
		imageload: function(src) {
			var result = $.Deferred();
			var img = $('<img onerror="this.src=\'' + FAIL + '\'" src="' + src + '">');
			function check() {
				img.off('load');
				var succeeded = !(img.attr('src') === FAIL);
				if (succeeded) {
					result.resolve(img.get(0));
				} else {
					result.reject({
						"src": src,
						"error": "Load failed"
					});
				}
			}
			if (img.get(0).complete) {
				check();
			} else {
				img.on('load', check);
			}
			return result.promise();
		}
	});
})(jQuery);

(function($) {
  var version_match = $(document.currentScript).attr("src").match(/^.*\-([\w]+)\.[\w\.]+$/);
  var version = (version_match ? version_match[1] : null) || "1";
  $.extend({ site: { version: ("v" + version) } });
})(jQuery);


(function($) {
  var Singleton = $.site.Singleton = function(object) {
    this.define = this.define.bind(this);
    this.define(object);
  };
  Singleton.prototype.define = function(object) {
    if (!object) { return; }
    for (var key in object) {
      if (key === "constructor") { continue; }
      var value = object[key];
      if (typeof value === "function") { value = value.bind(this); }
      this[key] = value;
    }
    return this;
  };
})(jQuery);

(function($) {
  $.site.Utils = new $.site.Singleton();
})(jQuery);

(function($) {
  $.site.Utils.define({
    isDev: location.href.indexOf("local") >= 0 ||
           location.href.indexOf("192.") >= 0
  });
})(jQuery);
//=require utils-blank.js

(function($) {
  $.site.Utils.define({
    meta: function(name) { return $('meta[name=' + name + ']').attr('content'); }
  });
})(jQuery);
if (!window['DispatchEvent']) {
  window['DispatchEvent'] = function(elem, eventName) {
    var event;
    // Non-IE
    if (typeof(Event) === 'function') {
        event = new Event(eventName);
    // IE
    } else {
        event = document.createEvent('Event');
        event.initEvent(eventName, true, true);
    }
    elem.dispatchEvent(event);
    return event;
  }
}
/* global DispatchEvent */

if (!window['Require']) {
  window['Require'] = (function() {
    var Require;
  
    function onstate(elem, state) {
      if (state === 'complete' || state === 'loaded' || state === 'error') {
        elem.onload = elem.onerror = elem.onreadystatechange = null;
        var required = Require.required[elem.id];
        required.finished = true;
        required.errored = state === 'error';
        if (required.errored) {
          Require.onerror();
        } else {
          Require.onload();
        }
      }    
    }
  
    function onload()  { onstate(this, 'complete'); }
    function onerror() { onstate(this, 'error'); }
    function onrsc()   { onstate(this, this.readyState); }  
  
    Require = function(id, src) {
      if (Require.required[id]) { return; } // Already loaded
      Require.required[id] = {src:src};
      
      var script = document.createElement('script');
      script.id = id;
      script.src = src;
      script.onload = onload;
      script.onerror = onerror;
      script.onreadystatechange = onrsc;
    
      // Note script load is async by default
      document.head.appendChild(script);
    };
    Require.required = {};
    Require.onload = Require.onerror = function() { DispatchEvent(window, 'require'); };
    return Require;
  })();
}
//=require once.js
/* global Require */

(function($) {
  // Allow retrying a require
  Require.retry = function(id) {
    var required = Require.required[id];
    if (required) {
      var loading = $(window).once().reset(id);
      // Note: jQuery.getScript prevents caching by default.
      // This is necessary for my google docs sites, because as of 11-Jul 2020
      // if you call gapi.init using a cached copy of the script when you have
      // your internet connection switched off, it silently fails - it doesn't
      // resolve it's promise. To the user it looks like it's hanging!
      // So the below prevents the code getting as far as gapi.init, as
      // loading the gapi library always fails when there's no internet.      
      $.getScript(required.src)
      .done(function() {
        loading.resolve();
      })
      .fail(function() {
        loading.reject();
      });
      return loading.promise();
    } else {
      console.error("script '" + id + "' not found!");
      return $.Deferred().reject().promise();
    }
  };
  
  // Convenience
  Require.once = function(id) {
    return $(window).once(id);
  };

  // Translate require events to promises
  function onrequire() {
    for (var id in Require.required) {
      var state = Require.required[id];
      var once = $(window).once().deferred(id);
      if (state.finished &&
          once.state() === 'pending')
      {
        if (state.errored) {
          once.reject();
        } else {
          once.resolve();
        }
      }
    }
  }
  $(window).on('require', onrequire);
  onrequire();
})(jQuery);
//=require require.js
/* global Require */

Require("gapi", "https://apis.google.com/js/api.js");

//=require site-blank.js

(function($) {
  function FatalError(message) {
    this.name = "FATAL";
    this.message = message;
  }
  FatalError.prototype = Object.create(Error.prototype); 

  function TimeoutError(message, millis) {
    this.name = "TIMEOUT";
    this.message = message;
    this.millis = millis;
  }
  TimeoutError.prototype = Object.create(Error.prototype); 

  $.site.FatalError   = FatalError;
  $.site.TimeoutError = TimeoutError;
})(jQuery);
/* global Require */

(function($) {
  var Utils = $.site.Utils;

  var Gauth = $.site.Gauth = {
    _init: function() {
      var gapiready = Require.once('gapi');
      if (gapiready.state() === 'rejected') {
        gapiready = Require.retry('gapi');
      }
      
      var gauthready = $(window).once().deferred('ready.gauth');
      if (gauthready.state() === 'rejected') {
        gauthready = $(window).once().reset('ready.gauth');
      }
      
      gapiready
      .done(function() {
        if (gauthready.state() !== 'pending') { return; } // Cancelled
        
        gapi.load('client:auth2', {
          callback: function() {
            if (gauthready.state() !== 'pending') { return; } // Cancelled
        
            var clientMeta = "google-signin-client_id-" + (Utils.isDev ? "dev" : "prod");
            var clientId   = Utils.meta(clientMeta);
            if (!clientId) {
              console.error("missing meta tag named '" + clientMeta + "' in html source");
              gauthready.reject("program error");
              return;
            }
      
            gapi.client.init({
              // Don't use api key, otherwise can't carry signin status across multiple tabs
              clientId: clientId,
              scope: 'profile email'
            }).then(function() {
              if (gauthready.state() !== 'pending') { return; } // Cancelled
          
              var gauth = gapi.auth2.getAuthInstance();
         
              gauthready.resolve(gauth.currentUser.get());
              
              // Listen for future sign-in state changes
              gauth.isSignedIn.listen(function(e) {
                $(window).trigger('signin.gauth', e);
              });
              gauth.currentUser.listen(function(e) {
                $(window).trigger('user.gauth', e);
              });
        
            }, function() {
              gauthready.reject("gapi client init failed");
            });
          },
          onerror: function() {
            gauthready.reject("gapi auth load failed");
          },
          timeout: 10000,
          ontimeout: function() {
            gauthready.reject("gapi auth load timeout");
          }
        });
      })
      .fail(function() {
        gauthready.reject("gapi script load failed");
      });
      return this;
    },
    
    ready: function() { return $(window).once('ready.gauth'); },
    get: function() { return this.ready().state() === 'resolved' ? gapi.auth2.getAuthInstance() : null; },
    getUser: function() {
      var gauth = this.get();
      if (gauth) {
        var user = gauth.currentUser.get();
        if (user && user.getId()) {
          return user;
        }
      }
      return null;
    },
    isSignedIn: function() {
      var gauth = this.get();
      if (gauth) {
        return gauth.isSignedIn.get();
      }
      return false;
    },
    init: function() {
      this._init();
    },
    retry: function() {
      this._init();
    }
  };
  
  Gauth.init();
})(jQuery);
//=require site-blank.js

(function($) {
  var _;
  var Hide;

	function Request(configurer) {
	  this.configurer = configurer;
	}
	_ = Request.prototype;

	_.hidden = function() {
	  return this === Hide;
	};

	_.description = function() {
	  return this.hidden() ? "hide" : "show";
	};

	Hide = new Request();

  function Alert(selector) {
    this.selector = selector;
    this.onshown = this.onshown.bind(this);
    this.onhidden = this.onhidden.bind(this);
    this.onclose = this.onclose.bind(this);

    $(document).ready(function() {
      var $alert = this.$();
      $alert.on('hidden.bs.collapse', this.onhidden);
      $alert.on('shown.bs.collapse', this.onshown);
      $alert.find('.btn-close').click(this.onclose);
      this.ready = true;
      this.onhidden();
    }.bind(this));
  }
  _ = Alert.prototype;

  _.$ = function() {
    return $(this.selector);
  };

  _.onhidden = function() {
    this.collapsing = false;
    if (this.pausing) { clearTimeout(this.pausing); }
    this.pausing = setTimeout(function() {
      this.pausing = null;
      this._onhidden();
    }.bind(this), 600);
  };

  _._onhidden = function() {
    this.currentRequest = this.pendingRequest;
    this.pendingRequest = null;
    if (this.currentRequest) {
      this._start();
    }
  };

  _.onshown = function() {
    this.collapsing = false;
    if (this.pausing) { clearTimeout(this.pausing); }
    this.pausing = setTimeout(function() {
      this.pausing = null;
      this._onshown();
    }.bind(this), 1000);
  };

  _._onshown = function() {
    if (this.pendingRequest) {
      this._stop();
    }
  };

  _._hidden = function($alert)           { return !$alert.hasClass('show'); };
  _._show   = function($alert)           { $alert.collapse('show'); };
  _._hide   = function($alert)           { $alert.collapse('hide'); };

  _.hidden  = function()                 { return this._hidden(this.$()); };
  _.show    = function(configurer)       { this._toggle(true, configurer); };
  _.hide    = function()                 { this._toggle(false); };
  _.onclose = function()                 { this._toggle(false, undefined, true); }
  _.toggle  = function(show, configurer) { this._toggle(show, configurer); }

  _._toggle = function(show, configurer, immediate) {
    var request = show ? new Request(configurer) : Hide;

    if (!this.ready) {
      this.pendingRequest = request;
    } else {
      if (this.currentRequest) {
        if (this.currentRequest === request) {
          this.pendingRequest = null;
        } else {
          this.pendingRequest = request;
          this._stop(immediate);
        }
      } else {
        this.currentRequest = request;
        this.pendingRequest = null;
        this._start();
      }
    }
  };

  _._stop = function(immediate) {
    if (this.collapsing) { return; }

    if (!this.pausing || immediate) {
      clearTimeout(this.pausing);
      this.pausing = null;
      var $alert = this.$();
      if (!this._hidden($alert)) {
        this.collapsing = true;
        this._hide($alert);
      } else {
        this._onhidden();
      }
    }
  };

  _._start = function() {
    if (this.collapsing) { return; }

    if (this.currentRequest.hidden()) {
      this._stop();
    } else {
      var $alert = this.$();
      if (this.currentRequest.configurer) {
        this.currentRequest.configurer($alert[0]);
      }
      if (this._hidden($alert)) {
        this.collapsing = true;
        this._show($alert);
      } else {
        this._onshown();
      }
    }
  };

  $.site.Alert = Alert;
})(jQuery);

(function($) {
  $.fn.extend({
    toggleVisibility: function(visible) {
      if (visible === undefined) {
        visible = !this.is(":visible");
      }
      this.css("visibility", visible ? "visible" : "hidden");
    }
  });
} (jQuery));

//=require utils-meta.js
//=require utils-env.js
//=require utils-blank.js

(function($) {
  $.site.Utils.define({
    queryparam: function (param, defaultValue = undefined) {
      if (location.search) {
        location.search.substr(1)
          .split("&")
          .some(function(item) {
            return item.split("=")[0] == param && (defaultValue = item.split("=")[1], true)
          });
      }
      return defaultValue;
    },

    addQueryparam: function(url, name, val) {
      if (!url) { url = location.href; }
      return url + (/\?/.test(url) ? '&' : '?') + name + (val ? '=' + val : '');
    },

    addQueryparamNow: function(url) {
      return this.addQueryparam(url, '_', Date.now());
    }
  });
})(jQuery);

//=require utils-blank.js

(function($) {
  $.site.Utils.define({
    lastPathComponent: function(path) {
      var indexSlash = path.lastIndexOf("/");
      return indexSlash <= 0
        ? ""
        : path.substring(indexSlash + 1);
    },
    deletingLastPathComponent: function(path) {
      var indexSlash = path.lastIndexOf("/");
      return indexSlash <= 0
        ? ""
        : path.substring(0, indexSlash);
    }
  });
})(jQuery);

//=require site-blank.js
//=require site-blank.js

(function($) {
  var _;
  
  // Running
  var Running = function(poll) {
    this.poll = poll;
    this.cancelled = false;
  };
  _ = Running.prototype;
  
  _.cancel = function() {
    if (!this.cancelled && !this.discarded) {
      this.cancelled = true;
      if (this.poll.running === this) { delete this.poll.running; }
      if (this.request) { this.request.abort(); delete this.request; }
      if (this.timeout) { clearTimeout(this.timeout); }
    }
  };
  
  _.discard = function() {
    if (!this.discarded) {
      this.discarded = true;
      if (this.poll.running === this) { delete this.poll.running; }
    }
  };
  

  // Poller
  var Poller = function(controller, id, def, callback, options) {
    this.controller = controller;
    this.id = id;
    this.def = typeof def === "object" ? Object.assign({}, def) : {url: ("" + def)};
    this.def.cache = false;
    this.callback = callback;
    if (typeof options === "number") {
      this.delay = options;
    } else if (typeof options === "object") {
      this.delay = "delay" in options && typeof options.delay === "number" ? options.delay : 5000;
      this.manual = "manual" in options ? !!options.manual : false;
    }
  };
  _ = Poller.prototype;
  
  _.poll = function(delays) {
    if (!this.controller.isStopped) {
      this.schedule(delays || 0);
    }
  };
  
  _.start = function(millisSpentBlurred) {
    if (!this.manual) {
      this.schedule(millisSpentBlurred >= 3000 ? [100] : undefined);
    }
  };
  
  _.stop = function() {
    if (this.running) { this.running.cancel(); }
  };
  
  _.schedule = function(delays) {
    if (this.running) { this.running.cancel(); }
    var running = this.running = new Running(this);
    
    var millis;
    if (Array.isArray(delays)) {
      millis = delays.shift();
      if (delays.length == 0) { delays = undefined; }
    } else if (typeof delays === "number") {
      millis = delays;
    } else {
      delays = millis = undefined;
    }
    
//     console.log("[poll::" + this.id + "::schedule] delay = " + millis);
    
    if (millis === undefined) { millis = this.delay; }
    
    if (millis > 0) {
      running.timeout = setTimeout((function() {
        delete running.timeout;
        this.execute(delays, running); // Can't have been cancelled, otherwise already killed by timeout.
      }).bind(this), millis);
    } else {
      this.execute(delays, running);
    }
  };
  
  _.execute = function(delays, running) {
    this.lastPollTime = Date.now();
    var def = this.def;
    var request = running.request = $.ajax(def);
    request
    .done((function(data, textStatus) {
      if (running.cancelled) { return; }
      var result = this.callback(data, textStatus, request, running);
      if (running.cancelled) { return; }
      
      if (result) {
        // If the result is a $.Deferred, then bind(this) doesn't work for the function
        // passed to always(). So must nest it.
        var completion = (function() {
          this.finished(undefined, running); // After a reload, discard the custom delays list.
        }).bind(this);
        return result.always(function() {
          completion();
        });
      } else {
        this.finished(delays, running);
      }
    }).bind(this))
    .fail((function(jqXHR, textStatus, errorThrown) {
      if (!running.cancelled) {
        console.error("[poll::" + this.id + "::error] [" + def.url + "] " + textStatus + (errorThrown ? ": " + errorThrown : ""));
      }
      this.finished(delays, running);
    }).bind(this));
  };
  
  _.finished = function(delays, running) {
    if (!running.cancelled) {
      running.discard();
      if (!this.manual) {
        this.schedule(delays);
      }
    }
  };  


  // Controller
  var Controller = function() {
    this.onWindowFocus = this.onWindowFocus.bind(this);
    this.onWindowBlur = this.onWindowBlur.bind(this);
    this.polls = {};
        
    this.hasFocus = true;
    this.isStopped = true;
    
    $(window).on("focus", this.onWindowFocus);
    $(window).on("blur", this.onWindowBlur);
    $(window).on("unload", this.onWindowBlur);
    
    $(document).ready(function() {
      if (this.hasFocus) {
        this.onWindowFocus();
      }
    }.bind(this));
  };
  _ = Controller.prototype;
  
  _.onWindowFocus = function() {
    this.hasFocus = true;
    if (!$.isReady) { return; }
    this.isStopped = false;
        
    var millisSpentBlurred = this.lastBlurTime ? Date.now() - this.lastBlurTime : 0;
    for (var id in this.polls) {
      var poll = this.polls[id];
      poll.start(millisSpentBlurred);
    }  
  };
  
  _.onWindowBlur = function() {
    this.isStopped = true;
    this.hasFocus = false;
    this.lastBlurTime = Date.now();
    
    for (var id in this.polls) {
      var poll = this.polls[id];
      poll.stop();
    }
  };
  
  _.add = function(id, def, callback, options) {
    this.remove[id];
    var poll = this.polls[id] = new Poller(this, id, def, callback, options);
    if (!this.isStopped) {
      poll.start();
    }
    return poll;
  };
  
  _.remove = function(id) {
    var poll = this.polls[id];
    delete this.polls[id];
    if (poll) { poll.stop(); }
  };
  
	$.site.Poll = new Controller();
})(jQuery);
(function($) {
  var _;
  var DEFAULT_TIMEOUT = 1000*60*60*12; // 12 hours

  function Page(pages, hash, target) {
    this.pages = pages;
    this.setHash(hash);
    this.target = target;
    pages.onNewPage(this);
  }
  _ = Page.prototype;

  _.setHash = function(hash, options) {
    if (!hash || !(typeof hash === "string")) {
      hash = "";
    } else {
      hash = hash.trim();
      // Must start with '#'
      if (hash.length > 0 && !hash.startsWith("#")) { hash = "#" + hash; }
      // Remove excess '/' characters
      hash = hash.replace(/^(.+?)\/*?$/, "$1").replace(/\/\/+/g, '/').replace(/^#\//, '#');
      if (hash === "#") { hash = ""; }
    }
    this.hash = hash;

    // Replace mangled hash with clean hash (e.g. too many slashes)
    if (hash !== location.hash && !(options && options.visible === false)) {
      history.replaceState(undefined, undefined, location.href.split("#", 2)[0] + hash);
    }

    var components = (hash.startsWith("#") ? hash.substring(1) : hash).split("?", 2);
    this.path      = components.shift();
    this.qs        = components.shift();
    var source     = this.source();
    this.valid     = source && !!source[0];
    this.href      = !this.valid ? null : source.attr('href') || source.attr('data-href');
    this.type      = !this.valid ? null : source.attr('data-page');
  };

  _.source = function() {
    if (this.hash.length == 0) { return null; }
    return $('[data-page][href$="' + this.hash + '"], [data-page][data-href$="' + this.hash + '"], [data-page][data-href-alt~="' + this.hash + '"]');
  };

  function Pages() {
    this._enabled = false;
    this.onHashChange = this.onHashChange.bind(this);
    this.onClick = this.onClick.bind(this);
    this.clickTarget = null;
  }
  _ = Pages.prototype;

  _.init = function() {
    var options = this.options;
    if (options && options.initPages) {
      options.initPages(this);
    }
  };

  _.start = function(options) {
    if (options) { this.options = options; }
    this.enabled(true);
  };

  _.showPage = function(hash) {
    if (location.hash === hash) {
      this.onHashChange();
    } else {
      location.href = hash;
    }
  };

  _.shouldReload = function(page) {
    var options = this.options;
    var timeout = DEFAULT_TIMEOUT;
    if (options && options.timeout !== undefined) { timeout = 0 + options.timeout; }
    if (timeout > 0 && this.startTime) {
      var elapsed = Date.now() - this.startTime;
      if (elapsed > timeout) {
        return true;
      }
    }

    if (options && options.shouldReloadPage) {
      return options.shouldReloadPage(page);
    } else {
      return false;
    }
  };

  _.onNewPage = function(page) {
    var options = this.options;
    if (options && options.initPage) {
      options.initPage(page);
    }
  };

  _.onClick = function(evt) {
    var href = $(evt.target).attr("href");
    var isHash = href && href.startsWith("#");
    if (isHash) {
      this.clickTarget = evt.target;
    } else if (this.clickTarget) {
      this.clickTarget = null;
    }
  };

  _.onHashChange = function() {
    var clickTarget = this.clickTarget;
    if (clickTarget) { this.clickTarget = null; }
    var page = new Page(this, location.hash, clickTarget || window);
    this.pages = page;

    // Reload from server
    if (this.shouldReload(page)) {
      // Don't reload everything, just HTML page (should be set to no-cache)
      location.reload(false);

    // Fire event
    } else {
      $(window).trigger("page.pages", page);
    }
  };

  _.ifStillOnSamePage = function(func) {
    var page = this.page;
    return function() { if (this.page === page) { func(); }  }
  };

  _.enabled = function(enabled) {
    var wasEnabled = this._enabled;
    if (enabled === undefined) { return wasEnabled; }

    enabled = !!enabled;
    if (enabled === wasEnabled) { return; }
    this._enabled = enabled;

    if (enabled) {
      $(document).ready(function() {
        if (this._enabled) {
          var wasStarted = this.startTime !== undefined;
          if (!wasStarted) {
            this.startTime = Date.now();
            this.init();
          }
          $(document).on('click.pages', this.onClick);
          $(window).on('hashchange.pages', this.onHashChange);
          if (!wasStarted) { this.onHashChange(); }
        }
      }.bind(this));
    } else {
      $(window).off('hashchange.pages').off('click.pages');
    }
  };

  Pages.Page = Page;

  $.extend({
    pages: new Pages()
  });
})(jQuery);


(function($) {
  var _;
  var Poll = $.site.Poll;
  
  var PagesPollOptions = function() {};
  _ = PagesPollOptions.prototype;
  
	_.initPages = function(pages) {
	  var ajax = {url: location.href, method: "HEAD"};
    this.stalePoller = Poll.add("pages-stale", ajax, function(data, statusText, request) {
      var modified = request.getResponseHeader("Last-Modified");
      if (!this.isEqualLastModified(modified)) {
        this.stale = true;
      }
    }.bind(this), { manual: true });
	};
	
	_.timeout = 1000*60*60*24; // 1 day
	
	_.shouldReloadPage = function(page) {
	  if (this.stale) { return true; }
	  if (!page.pages.startTime) { return false; }
	  
	  var lastPollTime = this.stalePoller.lastPollTime || page.pages.startTime;
	  var elapsed = Date.now() - lastPollTime;
	  if (elapsed > 1000 * 10) { this.stalePoller.poll(); }
	  
	  return false;
	}	;
	
	_.isEqualLastModified = function(lastModified) {
	  var d1 = new Date(document.lastModified);
	  var d2 = new Date(lastModified);
	  if (isNaN(d2)) { return false; }
	  
	  // Document.lastModified returns date without timezone, but ajax request lastModified
	  // header includes timezone. As of 6-Oct-2019, for document.lastModified,
	  // Firefox leaves the header as-is (minus the timezone), whereas Safari converts it
	  // to browser's timezone. E.g. Firefox returns "10/06/2019 20:00" but Safari returns
	  // "10/06/2019 22:00", whereas the server's true last modified is
	  // "06 Oct 2019 20:00 GMT". So do a slightly flaky calculation to allow for this.
	  // Note this will give a false positive in situations where the file is changed on the
	  // server, and the difference in times between the old file and the new one happens to
	  // exactly match any user's timezone difference.
	  if (d1.getTime() === d2.getTime()) { return true; }
    if (d1.getTime() - (d1.getTimezoneOffset() * 60 * 1000) === d2.getTime()) { return true; }
	  return false;
	};
  
	$.site.PagesPollOptions = PagesPollOptions;
})(jQuery);


(function($) {
  var _;
  var Alert = $.site.Alert;
  var Gauth = $.site.Gauth;
  var Utils = $.site.Utils;
  var PagesPollOptions = $.site.PagesPollOptions;

  function PagesOptions(preferListView) {
    PagesPollOptions.prototype.constructor.call(this); // Inheritance
    this.preferListView = preferListView;
  }
  PagesOptions.prototype = Object.create(PagesPollOptions.prototype); // Inheritance
  PagesOptions.prototype.constructor = PagesPollOptions; // Inheritance
  _ = PagesOptions.prototype;

  _.initPage = function(page) {
    if (!page.valid) { return; }
    var source = page.source();
    if (source.length > 1) {
      // Try to choose most recent year
      var thisYear = new Date().getFullYear();
      var bestYear = 0;
      var $bestSource;
      $.each(source, function(_, source) {
        var $source = $(source);
        var href = $source.attr('href') || $source.attr('data-href');
        if (!href) { return; }
        var pathComponent = Utils.lastPathComponent(href);
        if (!/\d\d\d\d/.test(pathComponent)) { return; }
        var year = parseInt(pathComponent);
        if (isNaN(year)) { return; }
        if (year == thisYear) {
          $bestSource = $source;
          return false;
        }
        if ((bestYear > thisYear && bestYear > year)
        || (bestYear < thisYear && bestYear < year)) {
          $bestSource = $source;
          bestYear = year;
        }
      });
      if (!$bestSource) {
        $bestSource = source.first();
      }
      var href = $bestSource.attr('href') || $bestSource.attr('data-href');
      page.setHash(href, { visible: false });
      source = $bestSource;
    }

    page.pid = source.attr('data-pid');
    page.did = source.attr('data-did');
    page.gid = source.attr('data-gid');
    page.oid = source.attr('data-oid');
    page.src = source.attr('data-src');

    if (page.type === "folder") {
      page.isListView = this.preferListView;
    }

    this.initPageUrls(page);
  };

  _.initPageUrls = function(page) {
      var urls = this.urls[page.type];
      page.url = urls ? urls.show(page) : null;
      page.openUrl = urls ? urls.open(page) : null;
      page.valid = !!urls;
  };

  _.urls = {
    plain: {
      show: function(page) { return Utils.addQueryparamNow(page.src); },
      open: function(page) { return Utils.addQueryparamNow(page.src); }
    },
    sheet: {
      show: function(page) { return "https://docs.google.com/spreadsheets/d/" + page.did + "/htmlembed?chrome=false&widget=false&headers=false" + (page.gid ? "&single=true&gid=" + page.gid : ""); },
      open: function(page) { return "https://docs.google.com/spreadsheets/d/" + page.did + "/edit" + (page.gid ? "#gid=" + page.gid : ""); }
    },
    chart: {
      show: function(page) { return "https://docs.google.com/spreadsheets/d/" + page.did + "/embed/oimg?id=" + page.did + "&oid=" + page.oid + "&filetype=svg"; },
      open: function(page) { return "https://docs.google.com/spreadsheets/d/" + page.did + "/edit" + (page.gid ? "#gid=" + page.gid : ""); }
    },
    folder: {
      show: function(page) { return "https://drive.google.com/embeddedfolderview?id=" + page.did + "#" + (page.isListView ? "list" : "grid"); },
      open: function(page) { return "https://drive.google.com/open?id=" + page.did; }
    }
  };

  _.toggleListView = function(page) {
    if (page.type === "folder") {
      this.preferListView = page.isListView = !page.isListView;
      this.initPageUrls(page);
    }
  };

  function GUI() {
    this.alert = new Alert('.s-alert');
  }
  _ = GUI.prototype;

  _.initClickToReload = function() {
    // Reload on click already-selected page
    $(document).on("click", function(event) {
      var $link = $(event.target).closest("[href], [data-href]");
      if ($link.length == 0) { return; }

      // Not a page link, e.g. toggle dark/light mode
      var href = $link.attr("href") || $link.attr("data-href");
      if (!(href && href.length > 1 && href.startsWith("#"))) {
        return;
      }

      // Double-click
      if (event.detail > 1) {
        location.reload(false);

      // Single-click, but hash not changing, so force content reload
      } else if (href === location.hash) {
        $(window).trigger("content.reload");
      }
    });
  };

  _.initPageTabsDropdowns = function() {
    // Hover of dropdowns inside a CSS .overflow must be handled with javascript,
    // becaue the .overflow causes the dropdown menu to be clipped (hidden)
    // when using the CSS 'display: block' to show it on hover because it is
    // inside a different stacking context to the document.
    // Instead, use bootstrap's popper library to position the dropdown using 'fixed'.
    $('.s-tabbar .dropdown').on("mouseenter", function() {
      var $this = $(this);
      if(!$this.find('.dropdown-menu').is(':visible')) {
        var dropdownToggle = $this.find('.dropdown-toggle').get(0);
        var dropdown = new window.bootstrap.Dropdown(dropdownToggle, {
          offset: [0,0], // Prevent gap between button and menu, causing hover to stop
          popperConfig(defaultBsPopperConfig) {
            var newPopperConfig = Object.assign({}, defaultBsPopperConfig);
            newPopperConfig.strategy = 'fixed';
            return newPopperConfig
          }
        });
        dropdown.show();
      }
    }).on("mouseleave", function() {
      var $this = $(this);
      var dropdownToggle = $this.find('.dropdown-toggle').get(0);
      var dropdown = window.bootstrap.Dropdown.getInstance(dropdownToggle);
      if (dropdown) {
        dropdown.hide();
        // Bootstrap automatically focuses tab on show, meaning it is now
        // focussed and text is blue colour.
        dropdownToggle.blur();
      }
    });
  };

  _.contentMask = function(enabled) {
    var wasEnabled = $("#content-mask").length > 0;
    if (enabled === undefined) { return wasEnabled; }

    if (enabled) {
      if (!wasEnabled) {
        $(".s-content").append('<div id="content-mask" style="z-index:100;background-color:#fff"></div>');
      }
    } else {
      $("#content-mask").remove();
    }
  };

  _.content = function(enabled) {
    var wasEnabled = $("#content").length > 0;
    if (enabled === undefined) { return wasEnabled; }

    if (enabled) {
      var loading = $.Deferred();
      $("#content").remove();
      var $content;
      if (this.page.type === "chart") {
        $content = $('<object id="content" width="100%" height="100%" style="z-index:10" data="' + this.page.url + '"></object>');
      } else {
        $content = $('<iframe id="content" name="content" style="z-index:10" src="' + this.page.url + '"></iframe>');
      }
      $content.on("load", function() {
        $(this).off("load", "error");
        loading.resolve();
      });
      // Note: on Safari 13-July 2020 this never gets called. The iframe just hangs :-(
      $content.on("error", function() {
        $(this).off("load", "error");
        loading.reject();
      });
      $(".s-content").append($content);
      return loading.promise();
    } else {
      $("#content").remove();
      return null;
    }
  };

  _.spinner = function(enabled) {
    var $spinner = $(".s-overlay-spinner");
    var wasEnabled = $spinner.is(":visible");
    if (enabled === undefined) { return wasEnabled; }
    $spinner.toggle(enabled);
  };

  _.tools = function(enabled) {
    var $tools = $(".s-overlay-tools > .s-tools");
    var wasEnabled = $tools.is(":visible");
    if (enabled === undefined) { return wasEnabled; }
    if (enabled) {
      $tools.children(".s-list")
        .attr("href", this.page.url.replace("#grid", "#list"))
        .toggle(this.page.type === "folder" && !this.page.isListView);
      $tools.children(".s-grid")
        .attr("href", this.page.url.replace("#list", "#grid"))
        .toggle(this.page.type === "folder" && !!this.page.isListView);
      $tools.children(".s-open")
        .attr("href", this.page.openUrl)
        .toggle(this.page.type !== "plain");
    }
    $tools.toggleVisibility(enabled);
  };

  _.initTools = function() {
    // Overlay
    var $toolsOverlay = $(".s-overlay-tools");
    $toolsOverlay.prepend($(".s-tools").clone());
    var $tools = $toolsOverlay.children(".s-tools")
    // List/grid
    $tools.find(".s-list, .s-grid").on("click", function(event) {
      $.pages.options.toggleListView(this.page);
      var $tools = $(event.currentTarget).closest(".s-tools");
      $tools.find(".s-list, .s-grid").toggle();
    }.bind(this));
    // Reload
    $tools.find(".s-reload").on("click", function(event) {
      $(window).trigger("content.reload");
      event.preventDefault();
      return false;
    });
  };

  _.reset = function() {
    $(".navbar .active").removeClass("active");
    $(".navbar-collapse.show").collapse('hide'); // Animate 'close' navbar on mobile
    this.signinPage(false);
    this.homePage(false);
    this.pageTabs(false);
    this.spinner(false);
    this.tools(false);
    this.contentMask(false);
    this.content(false);

    // Dismiss navbar dropdown menu
    var $nav = $("nav:not(.no-hover)");
    if ($nav.length > 0) {
      setTimeout(function() {
        $nav.addClass("no-hover");
        setTimeout(function() {
          $nav.removeClass("no-hover");
        }, 500);
      }, 100);
    }

    // Dismiss alert
    this.toggleAlert(false);
  };

  _.fatal = function(msg) {
    this.toggleAlert(true, "Oops...!", msg);
  };

  _.nogoogle = function() {
    this.fatal("There was a problem connecting to Google");
  };

  _.toggleAlert = function(show, title, msg) {
    this.alert.toggle(show, function(alert) {
      var $alert = $(alert);
      $alert.find(".s-alert-title").text(title);
      $alert.find(".s-alert-message").html(msg);
    });
  };

  _.toggleTheme = function(force_dark) {
    var wasDark = $('html[data-bs-theme="dark"]').length > 0;
    this.setTheme(!wasDark);
  };

  _.setTheme = function(dark) {
    if (dark) {
      $("html").attr("data-bs-theme", "dark");
    } else {
      $("html").removeAttr("data-bs-theme");
    }
    localStorage.setItem("dark", dark ? "true" : "false");
  };

  _.initTheme = function() {
    $(".s-theme-toggle").on("click", function(event) {
      this.toggleTheme();
      event.preventDefault();
      return false;
    }.bind(this));

    var preferDark = localStorage.getItem("dark");
    this.setTheme(preferDark === "true");
  };

  _.homePage = function(enabled) {
    var wasEnabled = $("#nav-home.active").length > 0;
    if (enabled === undefined) { return wasEnabled; }

    if (enabled) {
      $("#nav-home a").addClass("active");
      $(".s-background").addClass("active");
      $(".navbar").attr("data-bs-theme", "dark");
    } else {
      $("#nav-home a").removeClass("active");
      $(".s-background").removeClass("active");
      $(".navbar").removeAttr("data-bs-theme");
    }
  };

  _.pageTabs = function(enabled) {
    var $activeTabBars = $(".s-tabbar.active");

    if (enabled === undefined) {
      return $activeTabBars.length > 0;
    }

    // Hide
    if (!enabled) {
      $activeTabBars.removeClass(["active", "multi-level"]);
      $activeTabBars.find(".active").removeClass("active");

    // Show
    } else {
      // Show this tab
      var $tab = this.page.source();
      var $target = $(this.page.target);
      var isClickSameTabs = hasSameTabs($tab, $target);
      activateTab($tab, !isClickSameTabs);

      // Show parent tabs
      var hrefAlt = $tab.attr("data-href-alt");
      if (hrefAlt) {
        var selectors = hrefAlt.split(" ").map(function(href) {
          return '[href="' + href + '"]';
        });
        var $parentTabs = $(".s-tabbar " + selectors.join(""));
        if ($parentTabs.length > 0) {
          $parentTabs.each(function(i, parentTab) {
            var $parentTab = $(parentTab);
            var isClickSameParentTabs = hasSameTabs($parentTab, $target);
            activateTab($parentTab, !isClickSameTabs && !isClickSameParentTabs);
          });

          // Re-fetch so can detect if multi-level
          $activeTabBars = $(".s-tabbar.active");
          if ($activeTabBars.length > 1) {
            $activeTabBars.addClass("multi-level");
          }
        }
      }

      // Highlight selected navbar tab
      var href = this.page.href;
      do {
        var navbarTab = $('.navbar [href$="' + href + '"]').first();
        if (navbarTab.length > 0) {
          navbarTab.addClass("active");
          var navbarTopTab = navbarTab.parent();
          while (navbarTopTab.length > 0 &&
                !navbarTopTab.hasClass("nav-item"))
          {
            navbarTopTab = navbarTopTab.parent();
          }
          navbarTopTab.find(".nav-link").first().addClass("active");
          break;
        }
      } while ((href = Utils.deletingLastPathComponent(href)).length > 0);
    }

    function hasSameTabs($tab, $target) {
      if (!($tab && $target)) { return false; }
      var $tabs = $tab.closest('.nav-tabs');
      var $targetTabs = $target.closest('.nav-tabs');
      return $tabs.get(0) === $targetTabs.get(0);
    }

    function activateTab($tab, scrollIntoView) {
      var $tabs = $tab && $tab.closest('.nav-tabs');

      // Show tabs
      $tabs.addClass("active");
      $tabs.closest('.s-tabbar').addClass("active");

      // Reset the dropdown names
      $tabs.find(".dropdown .nav-link[data-label]").each(function() {
        var $toolbarTab = $(this);
        $toolbarTab.text($toolbarTab.attr("data-label"));
      });

      // Highlight selected tab
      $tab.addClass("active");

      // Set the dropdown name
      if ($tab.hasClass("dropdown-item")) {
        var toolbarTab = $tab.closest(".dropdown").find(".nav-link");
        var baseName = toolbarTab.attr("data-label");
        if (!baseName) {
          baseName = toolbarTab.text();
          toolbarTab.attr("data-label", baseName);
        }
        toolbarTab.text(baseName + " | " + $tab.text()).addClass("active");
      }

      // Scroll into view
      if (scrollIntoView) {
        var $visibleTab = $tab.closest(".nav-item");
        if ($visibleTab.length > 0) {
          setTimeout(function() {
            $visibleTab.get(0).scrollIntoView({
              behavior: 'smooth', inline: 'center'
            });
          });
        }
      }
    }
  };

  _.signinPage = function(phase, onClick) {
    var wasEnabled = $(".s-signin.active").length > 0;
    if (phase === undefined) { return wasEnabled; }

    if (phase) {
      var logo, name;
      if (this.page.type === 'sheet' ||
        this.page.type === 'chart') {
        name = "Google Sheets";
        logo = "google-sheets-ead6a9b7.png";
      } else {
        name = "Google Drive";
        logo = "google-drive-b52abc1a.png";
      }
      $(".s-signin-logo img").attr("src", "images/" + logo);
      if (phase === 'denied') {
        $(".s-signin-heading").html("Restricted content");
        $(".s-signin-message").html("This " + name + " item has not been shared with you. Please request permission from the owner.");
        $("#s-signin-button").html("Switch user");
        $("#s-signin-button").off('click').click(onClick);
      } else {
        $(".s-signin-heading").html(name + " needs access");
        $(".s-signin-message").html("This site requires " + name + ". Please login to Google using the button below.");
        $("#s-signin-button").html("Sign in");
        $("#s-signin-button").off('click').click(onClick);
      }
      $(".s-signin").addClass("active");
    } else {
      $(".s-signin").removeClass("active");
    }
  };

  function Config() {
    this.permissionUrl = Utils.meta('google-drive-permission');
    this.preferListView = Utils.meta('google-folder-prefer-list-view') == "true";
  }

  function Permissions(delegate) {
    this.delegate = delegate;
    this.data = {};
  }
  _ = Permissions.prototype;

  _.reset = function() {
    this.data = {};
  };

  _.stale = function() {
    var staleId = new Date();
    for (var pid in this.pids) {
      this.data[pid].stale = staleId;
    }
  };

  _.get = function(page) {
    if (!page || !page.pid) { return $.Deferred().resolve().promise(); }

    var data = this.data[page.pid];
    if (!data) { data = this.data[page.pid] = {}; }

    if (!data.loading &&
        (
          !data.result ||
          data.stale ||
          (Date.now() - data.lastUpdated) > 1000*1)
        )
    {
      var stale = data.stale;
      var delegate = this.delegate;

      var loading = $.Deferred();
      data.loading = loading.promise();

      this.load(page).always(function(status) {
        var oldResult = data.result;
        var newResult = data.loading;
        data.loading = undefined;

        if (status !== 'failed') {
          if (data.stale === stale) {
            data.stale = undefined;
          }
          data.lastUpdated = Date.now();
          data.result = newResult;

          if (oldResult) {
            oldResult.always(function(oldStatus) {
              if (oldStatus !== 'failed' &&
                  oldStatus !== status)
              {
                delegate.onPagePermChange(page);
              }
            });
          }
        }

        if (status === 'allow') {
          loading.resolve(status);
        } else {
          loading.reject(status);
        }
      });
    }

    return data.result || data.loading;
  };

  _.load = function(page) {
    var loading = $.Deferred();

    // Send permission query request
    $.getJSON(this.delegate.config.permissionUrl, {
      id: page.pid,
      email: page.email
    })
    .done(function(response) {
      if (response.allowed) {
        loading.resolve('allow');
      } else {
        loading.reject('deny');
      }
    })
    .fail(function() {
      loading.reject('failed');
    });

    return loading.promise();
  };

  function Controller() {
    this.config         = new Config();
    this.gui            = new GUI();
    this.permissions    = new Permissions(this);
    this.created        = new Date();
    this.contentLoading = false;

    // Binds
    this.onPageChange      = this.onPageChange.bind(this);
    this.onPagePermChange  = this.onPagePermChange.bind(this);
    this.onUserChange      = this.onUserChange.bind(this);
    this.onSigninChange    = this.onSigninChange.bind(this);
    this.onAuthChange      = this.onAuthChange.bind(this);
    this.onClickSwitchUser = this.onClickSwitchUser.bind(this);
    this.onClickReload     = this.onClickReload.bind(this);
    this.onContentLoading  = this.onContentLoading.bind(this);
    this.onContentLoad     = this.onContentLoad.bind(this);
  }
  _ = Controller.prototype;

  _.start = function() {
    this.gui.initClickToReload();
    this.gui.initPageTabsDropdowns();
    this.gui.initTools();
    this.gui.initTheme();

    $(window).on('page.pages',      this.onPageChange)
             .on('user.gauth',      this.onUserChange)
             .on('signin.gauth',    this.onSigninChange)
             .on('ready.gauth',     this.onAuthChange)
             .on('content.reload',  this.onClickReload)
             .on('content.loading', this.onContentLoading)
             .on('content.load',    this.onContentLoad);

    $.pages.start(new PagesOptions(this.preferListView));
    this.started = true;
  };

  _.rebindOnClickReload = function() {
    $(window).off('content.reload').on('content.reload', this.onClickReload);
  };

  _.onContentLoading = function(e, contentPage) {
    if (this.page !== contentPage) { return; }
    if (this.contentLoading) { return; }
    this.contentLoading = true;
    this.gui.tools(false);
    this.gui.spinner(true);
    this.gui.toggleAlert(false);
  };

  _.onContentLoad = function(e, contentPage, errorMsg) {
    if (this.page !== contentPage) { return; }
    if (!this.contentLoading) { return; }
    this.contentLoading = false;
    this.gui.spinner(false);
    this.gui.tools(true);
    if (errorMsg) { this.gui.fatal(errorMsg); }
  };

  _.onClickReload = function() {
    this.onPageChange({}, this.page);
    return false;
  };

  _.onPageChange = function(event, page) {
    this.page = page;
    this.rebindOnClickReload();
    if (this.started) {
      if (Gauth.ready().state() === 'rejected') { Gauth.retry(); }
    }
    this.showPage();
  };

  _.onPagePermChange = function(page) {
    if (this.page === page) {
      this.showPage();
    }
  };

  _.onAuthChange = function(evt, data) {
    this.permissions.reset();
    if (this.page) {
      this.showPage();
    }
  };

  _.onSigninChange = function() {
    this.permissions.reset();
    if (this.page) {
      this.showPage();
    }
  };

  _.onUserChange = function() {
    if (this.page) {
      this.permissions.stale();
      this.showPage();
    }
  };

  _.onClickSwitchUser = function() {
    var gauth = Gauth.get();
    if (gauth) {
      // If have current user id, then must be signed in, so will get signin change
      // event when completes. If no current user, then trigger event manually.
      var completion = !Gauth.getUser() ? this.onSigninChange : undefined;
      gauth.signIn({"prompt":"select_account"})
      .then(function() {
        // Note: must nest completion in anonymous function to protect 'this'
        if (completion) { completion(); }
      });
    }
  };

  _.showPage = function() {
    this.gui.page = this.page;
    this.gui.reset();

    this.contentLoading = false;

    // Show home page
    if (!this.page.valid) {
      this.gui.homePage(true);
      return;

    // Show nav
    } else {
      this.gui.pageTabs(true);
    }

    // Toggle loading spinner
    this.gui.spinner(true);

    // Abort if google auth not ready
    var gauthready = Gauth.ready();
    if (gauthready.state() === 'pending') {
      return;
    } else if (gauthready.state() === 'rejected') {
      gauthready.fail((function() {
        this.gui.nogoogle();
        this.gui.spinner(false);
      }).bind(this));
      return;
    }

    // No user - show signin screen
    var user = Gauth.getUser();
    if (!user || !Gauth.isSignedIn()) {
      this.gui.signinPage('signin', this.onClickSwitchUser);
      this.gui.spinner(false);
      return;
    }
    this.page.email = user.getBasicProfile().getEmail();

    // Load content
    this.gui.contentMask(true);
    var loadingContent = this.gui.content(true);
    var loadingPermission = this.permissions.get(this.page);

    // Note: jQuery Deferred changes 'this', even if you bind it.
    var page = this.page;
    var ifStillOnSamePage = (function(callback) {
      if (this.page === page) { return callback.bind(this)(); }
    }).bind(this);

    // Permission
    loadingPermission
    .done(function() {
      ifStillOnSamePage(function() {
        // Permitted
        this.gui.contentMask(false);
        this.gui.signinPage(false);

        // Content
        return loadingContent
        .done(function() {
          ifStillOnSamePage(function() {
            // Content succeeded
            if (!this.contentLoading) {
              this.gui.spinner(false);
              this.gui.tools(true);
            }
          })
        })
        .fail(function() {
          ifStillOnSamePage(function() {
            // Content failed
            this.contentLoading = false;
            this.gui.nogoogle();
            this.gui.spinner(false);
          });
        });
      });
    })
    .fail(function(e) {
      ifStillOnSamePage(function() {
        this.contentLoading = false;
        // Denied
        if (e === 'deny') {
          this.gui.signinPage('denied', this.onClickSwitchUser);
          this.gui.spinner(false);
          this.gui.tools(false);
          this.gui.contentMask(false);
          this.gui.content(false);

        // Dropped connection
        } else {
          this.gui.nogoogle();
          this.gui.spinner(false);
        }
      });
    });
  };

  var controller = null;
  $(document).ready(function() {
    controller = new Controller();
    controller.start();
    $.site.controller = controller;
  });

})(jQuery);

